// extracted by mini-css-extract-plugin
export default {"wrapper":"AssetsDashboard_wrapper__BPSzq","tablesWrapper":"AssetsDashboard_tablesWrapper__uW6ub"};